import { type DOMOutputSpec, type NodeSpec } from "prosemirror-model";

export const table_row: NodeSpec = {
	content: "(table_cell | table_header)*",
	tableRole: "row",
	parseDOM: [{ tag: "tr" }],
	toDOM(): DOMOutputSpec {
		return ["tr", 0];
	},
};
